import { createContext } from "react";
import { doNothing } from "@edgetier/utilities";

import { ISidebarContext } from "./sidebar-context.types";

export const defaultContext: ISidebarContext = {
    isOpen: false,
    hideSidebar: doNothing,
    showSidebar: doNothing,
};

const SidebarContext = createContext<ISidebarContext>(defaultContext);
export default SidebarContext;
